import React, { useCallback, useMemo } from 'react';
import { Select } from '@moda/om';
import { SortOption } from '../../constants';

interface Props {
  currentSort: SortOption;
  availableSorts: SortOption[];
  onSortByChange?: (sort: string) => void;
  className?: string;
}

export const GridSortByDropdown: React.FC<Props> = ({
  currentSort,
  availableSorts,
  onSortByChange,
  className
}: Props) => {
  const handleChange = useCallback(
    (value: string) => onSortByChange && onSortByChange(value),
    [onSortByChange]
  );

  const options = useMemo(
    () => availableSorts.map(({ name: label, value }) => ({ label, value })),
    [availableSorts]
  );

  return (
    <Select
      idRef="GridSortByDropdown"
      className={className}
      label="Sort by"
      value={currentSort.value}
      options={options}
      onChange={handleChange}
    />
  );
};
